<template>
    <div class="table-responsive">
        <table class="table table-sm bordered-header">
            <thead>
                <tr>
                    <th class="text-nowrap">Değişilik Tarihi</th>
                    <th class="text-nowrap">Eski Tutar Tutar</th>
                    <th class="text-nowrap">Yeni Tutar</th>
                    <th class="text-nowrap">Tutar Değişim Açıklaması</th>
                    <th class="text-nowrap">Eski Dosya Numarası</th>
                    <th class="text-nowrap">Yeni Dosya Numarası</th>
                    <th class="text-nowrap">Dosya Numarası Değişim Açıklaması</th>
                    <th class="text-nowrap">Değişikliği Yapan Kişi</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(l,i) in value.logs" :key="i">
                    <td class="text-nowrap">{{ $safe(l,'ChangeDateStr') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'OldAmountStr') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'NewAmountStr') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'AmountChangeDescription') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'OldFileNumber') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'NewFileNumber') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'FileNumberChangeDescription') || '-' }}</td>
                    <td class="text-nowrap">{{ $safe(l,'CombineName') || '-' }}</td>
                </tr>
                <tr v-if="!(value.logs || []).length">
                    <td colspan="8" class="text-center text-muted">Kayıt yok.</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props:{
        value:{
            type:Object,
            default:() => ({
                fullName:null,
                logs:[]
            })
        }
    }
}
</script>